/* AMC quote add-ons: header quote icon, configured builds at checkout, clear option labels.
   Kept separate from amc-quote.js so both can change independently. */
(function () {
  'use strict';
  var PAGE = '/pages/build-a-quote';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var int = function (v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; };
  function ready(fn, tries) {
    tries = tries || 0;
    if (window.AMCQuote && typeof window.AMCQuote.items === 'function') return fn(window.AMCQuote);
    if (tries < 100) setTimeout(function () { ready(fn, tries + 1); }, 100);
  }
  ready(function (Q) {
    if (Q.__amcAddons) return; Q.__amcAddons = true;
    var priced = function (i) { return !i.custom && !i.quoteOnly && int(i.price, 0) > 0 && int(i.variantId, 0) > 0; };

    /* Same version-1 component manifest as direct walk-in add-to-cart. */
    function token() { return window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2); }
    function quantity(n) {
      n = Number(n);
      if (!Number.isSafeInteger(n) || n < 1 || n > 9999) throw new Error('Review the quote quantities before continuing.');
      return n;
    }
    Q.cartLines = function (list) {
      var out = [];
      (list || Q.items()).filter(priced).forEach(function (i) {
        if (i.available === false) throw new Error('A selected quote item is unavailable. Review the complete quote before continuing.');
        var b = i.amcBuild, q = quantity(i.qty), group = token();
        if (b && b.items && b.items.length) {
          var manifest = JSON.stringify({ version: 1, items: b.items.map(function (c) {
            return { id: String(c.id), ratio: quantity(c.qty), price: c.price };
          }) });
          var props = Object.assign({}, b.properties || {}, { '_AMC configuration': group, '_AMC build': manifest });
          b.items.forEach(function (c) {
            out.push({ id: Number(c.id), quantity: quantity(c.qty) * q, expectedPrice: c.price, properties: props });
          });
        } else {
          if (b) throw new Error('The configured quote is incomplete. Recreate it from the builder.');
          out.push({ id: Number(i.variantId), quantity: q, expectedPrice: i.amcGrossPrice || i.price, properties: Object.assign({}, i.properties || {}, { '_AMC quote line': group }) });
        }
      });
      return out;
    };
    async function request(url, options) {
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 20000);
      try {
        var r = await fetch(url, Object.assign({ credentials: 'same-origin', cache: 'no-store' }, options || {}, { signal: controller.signal }));
        if (!r.ok) throw new Error('Shopify did not confirm the cart request.');
        return await r.json();
      } finally { clearTimeout(timer); }
    }
    var checkoutBusy = false, cartReviewRequired = false;
    Q.checkout = async function (btn, source) {
      if (checkoutBusy) throw new Error('Your quote is already being checked.');
      if (cartReviewRequired) throw new Error('Review your cart before retrying; the previous quote may already have been added.');
      checkoutBusy = true;
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Checking items and prices...'; }
      try {
        var selected = Q.items().filter(priced), changed = false;
        if (!selected.length) throw new Error('No priced items');
        var fresh = await Promise.all(selected.map(async function (i) {
          var next;
          if (i.amcBuild) next = await Q.refreshBuild(i);
          else {
            var v = await Q.currentVariant(i.variantId);
            next = Object.assign({}, i, { price: v.price, amcGrossPrice: v.price, available: true });
            if (window.AMCNfda) next = window.AMCNfda.item(next);
          }
          if (i.price !== next.price || (i.amcBuild && JSON.stringify(i.amcBuild.items) !== JSON.stringify(next.amcBuild.items))) changed = true;
          return next;
        }));
        fresh.forEach(function (i) { Q.update(i.key, { price: i.price, amcPrice: i.amcPrice, amcGrossPrice: i.amcGrossPrice, amcPromotion: i.amcPromotion, amcBuild: i.amcBuild, properties: i.properties, available: true }); });
        if (changed) throw new Error('Current Shopify prices have changed. The quote has been updated; review its total and choose checkout again. Nothing was added.');
        var lines = Q.cartLines(fresh);
        if (btn) btn.textContent = 'Adding your complete quote...';
        // Once a write starts, never silently retry an uncertain response.
        cartReviewRequired = true;
        await request('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines.map(function (l) { return { id: l.id, quantity: l.quantity, properties: l.properties }; }) }) });
        var cart = await request('/cart.js', { headers: { Accept: 'application/json' } });
        if (!Array.isArray(cart.items)) throw new Error('Cart verification failed.');
        lines.forEach(function (expected) {
          var p = expected.properties, field = p['_AMC configuration'] ? '_AMC configuration' : '_AMC quote line';
          var matches = cart.items.filter(function (line) { return String(line.variant_id) === String(expected.id) && line.properties && line.properties[field] === p[field]; });
          if (matches.length !== 1) throw new Error('A quote component could not be confirmed in the cart.');
          var line = matches[0];
          if (line.quantity !== expected.quantity || line.original_price !== expected.expectedPrice || (line.price !== undefined && line.price !== expected.expectedPrice) || (p['_AMC build'] && line.properties['_AMC build'] !== p['_AMC build'])) throw new Error('A quote component quantity or price could not be confirmed.');
        });
        if (window.AMCNfda) await window.AMCNfda.apply();
        location.href = '/checkout';
      } catch (err) {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        if (cartReviewRequired) throw new Error('The cart response could not be confirmed. Open your cart and review its items and prices before trying again; this quote may already have been added.');
        throw err;
      } finally { checkoutBusy = false; }
    };

    /* A configured build keeps its configured price if the quote refreshes base prices */
    function keepBuildPrices() {
      var list = Q.items(), fix = false;
      list.forEach(function (i) { if (i.amcPrice && int(i.price, 0) !== int(i.amcPrice, 0)) fix = true; });
      if (!fix) return;
      list.forEach(function (i) { if (i.amcPrice && int(i.price, 0) !== int(i.amcPrice, 0)) Q.update(i.key, { price: int(i.amcPrice, 0) }); });
    }

    /* Header quote icon next to the cart */
    function headerIcon() {
      /* 2026-10-21: quote lives only in the yellow My Quote pill in the utility row */
      var old = document.querySelector('header .amc-quote-hd'); if (old) old.remove();
      document.documentElement.classList.remove('amc-has-qhd');
      if (true) return;
      var n = Q.count();
      var icon = document.querySelector('header .amc-quote-hd');
      if (!icon) {
        var cart = document.querySelector('header #cart-icon-bubble, header a.amc-hdr__cart, header a[href$="/cart"]');
        if (!cart) return;
        icon = document.createElement('a');
        icon.className = 'amc-quote-hd' + (cart.classList.contains('amc-hdr__tool') ? ' amc-hdr__tool' : '');
        icon.href = PAGE;
        icon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 3h7l5 5v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M14 3v5h5M9 12h6M9 16h6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><span class="amc-quote-hd__n" data-n></span><span class="amc-quote-hd__l">Quote</span>';
        icon.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || document.querySelector('[data-amc-qb]') || typeof Q.open !== 'function') return;
          e.preventDefault(); Q.open();
        });
        cart.parentNode.insertBefore(icon, cart);
        document.documentElement.classList.add('amc-has-qhd');
      }
      var pill = [].some.call(document.querySelectorAll('a, button'), function (a) { return a !== icon && !icon.contains(a) && /^\s*my quote\b/i.test(a.textContent || ''); });
      document.documentElement.classList.toggle('amc-qhd-alt', pill);
      var c = icon.querySelector('[data-n]'); c.textContent = n > 99 ? '99+' : String(n); c.hidden = !n;
      icon.setAttribute('aria-label', n ? 'Your quote, ' + n + (n === 1 ? ' item' : ' items') : 'Your quote');
    }

    /* Bold option headlines on quote lines (quote page and drawer) */
    function boldProps() {
      var byKey = {}; Q.items().forEach(function (i) { byKey[i.key] = i; });
      document.querySelectorAll('.amc-qb__item[data-key] .amc-qb__props:not([data-amc-b])').forEach(function (el) {
        var i = byKey[el.closest('[data-key]').dataset.key]; if (!i || !i.properties) return;
        el.innerHTML = Object.keys(i.properties).map(function (k) { return '<span class="amc-qb__prop"><b>' + esc(k) + ':</b> ' + esc(i.properties[k]) + '</span>'; }).join('');
        el.setAttribute('data-amc-b', '');
      });
      document.querySelectorAll('.amc-qd__list li[data-key] .amc-qd__info').forEach(function (info) {
        if (info.querySelector('.amc-qd__props')) return;
        var i = byKey[info.closest('[data-key]').dataset.key]; if (!i || !i.properties || !Object.keys(i.properties).length) return;
        var s = document.createElement('span'); s.className = 'amc-qd__props';
        s.innerHTML = Object.keys(i.properties).map(function (k) { return '<span><b>' + esc(k) + ':</b> ' + esc(i.properties[k]) + '</span>'; }).join('');
        var ctl = info.querySelector('.amc-qd__ctl'); info.insertBefore(s, ctl || null);
      });
    }

    var t = 0;
    function sync() { clearTimeout(t); t = setTimeout(function () { keepBuildPrices(); headerIcon(); boldProps(); }, 30); }
    document.addEventListener('amc:quote:change', sync);
    window.addEventListener('storage', sync);
    new MutationObserver(function (m) {
      for (var k = 0; k < m.length; k++) {
        var tg = m[k].target;
        if (tg.nodeType === 1 && (tg.matches('.amc-qd__list, [data-amc-qb] ul, .amc-qb__list') || tg.closest('.amc-qd, [data-amc-qb]'))) { boldProps(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    sync();
  });
})();

/* Contact panel: hover / focus / tap on "Contact us" or the header phone pill */
(function () {
  'use strict';
  var HOURS = { tz: 'America/New_York', days: [1, 2, 3, 4, 5], open: 9, close: 17, label: 'Mon\u2013Fri \u00b7 9 AM\u20135 PM ET' };
  var panel = null, owner = null, timer = 0, fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  function nowET() {
    var p = {}; new Intl.DateTimeFormat('en-US', { timeZone: HOURS.tz, weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var d = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday), h = (parseInt(p.hour, 10) % 24) + parseInt(p.minute, 10) / 60;
    return { d: d, h: h };
  }
  function status() {
    var n = nowET(), open = HOURS.days.indexOf(n.d) > -1 && n.h >= HOURS.open && n.h < HOURS.close;
    if (open) return { open: true, text: 'Open now', sub: 'Specialists available until 5 PM ET' };
    var next = (HOURS.days.indexOf(n.d) > -1 && n.h < HOURS.open) ? 'today' : (n.d >= 0 && n.d <= 4) ? 'tomorrow' : 'Monday';
    return { open: false, text: 'Closed now', sub: 'Opens ' + next + ' at 9 AM ET \u00b7 leave a message anytime' };
  }
  function build() {
    panel = document.createElement('div');
    panel.className = 'amc-cp'; panel.id = 'amcContactPanel'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'Contact American Mortuary Coolers'); panel.hidden = true;
    panel.innerHTML = '<div class="amc-cp__top"><span class="amc-cp__dot" data-cp-dot></span><b data-cp-state></b><span class="amc-cp__sub" data-cp-sub></span></div>' +
      '<a class="amc-cp__tel" href="tel:+18887929315"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M5.2 3.5h3l1.6 4.2-2.1 1.4a11.5 11.5 0 0 0 5.2 5.2l1.4-2.1 4.2 1.6v3a2 2 0 0 1-2.2 2A16.6 16.6 0 0 1 3.2 5.7a2 2 0 0 1 2-2.2z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/></svg><span><small>Call a specialist</small>1-888-792-9315</span></a>' +
      '<p class="amc-cp__hours">' + HOURS.label + '</p>' +
      '<div class="amc-cp__acts"><a href="mailto:cool@mymortuarycooler.com"><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M3 6h18v12H3zM3 7l9 6 9-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>Email us</a>' +
      '<a href="/pages/contact-us"><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M4 5h16v11H8l-4 4z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>Send a message</a>' +
      '<a href="/pages/build-a-quote"><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h6" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>Get a quote</a></div>';
    document.body.appendChild(panel);
    panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
    panel.addEventListener('mouseleave', function () { if (fine) later(); });
    panel.addEventListener('click', function (e) { var a = e.target.closest('a'); if (a && /^tel:/.test(a.getAttribute('href'))) { (window.dataLayer = window.dataLayer || []).push({ event: 'amc_nav_call', source: 'contact_panel' }); } });
  }
  function place(t) {
    var r = t.getBoundingClientRect(), w = Math.min(320, innerWidth - 24);
    panel.style.width = w + 'px';
    var left = Math.max(12, Math.min(r.left + r.width / 2 - w / 2, innerWidth - w - 12));
    panel.style.left = left + 'px'; panel.style.top = Math.round(r.bottom + 10) + 'px';
    panel.style.setProperty('--cp-arrow', Math.max(18, Math.min(w - 18, r.left + r.width / 2 - left)) + 'px');
  }
  function open(t) {
    if (!panel) build();
    clearTimeout(timer);
    var s = status();
    panel.querySelector('[data-cp-state]').textContent = s.text;
    panel.querySelector('[data-cp-sub]').textContent = s.sub;
    panel.classList.toggle('is-open-now', s.open);
    if (owner && owner !== t) owner.setAttribute('aria-expanded', 'false');
    owner = t; t.setAttribute('aria-expanded', 'true'); t.setAttribute('aria-controls', 'amcContactPanel');
    place(t); panel.hidden = false;
    requestAnimationFrame(function () { panel.classList.add('is-in'); }); setTimeout(function () { if (owner === t && !panel.hidden) panel.classList.add('is-in'); }, 60);
  }
  function close() {
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-in'); if (owner) owner.setAttribute('aria-expanded', 'false');
    setTimeout(function () { if (!panel.classList.contains('is-in')) panel.hidden = true; }, 160);
  }
  function later() { clearTimeout(timer); timer = setTimeout(close, 220); }
  document.addEventListener('mouseover', function (e) { if (!fine) return; var t = e.target.closest && e.target.closest('[data-amc-contact]'); if (t) open(t); });
  document.addEventListener('mouseout', function (e) { if (!fine) return; var t = e.target.closest && e.target.closest('[data-amc-contact]'); if (t && !(e.relatedTarget && (t.contains(e.relatedTarget) || (panel && panel.contains(e.relatedTarget))))) later(); });
  document.addEventListener('focusin', function (e) { var t = e.target.closest && e.target.closest('[data-amc-contact]'); if (t) { var kb = true; try { kb = t.matches(':focus-visible'); } catch (x) {} if (kb) open(t); } else if (panel && !panel.contains(e.target)) close(); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-amc-contact]');
    if (t && !fine && (panel === null || panel.hidden || owner !== t)) { e.preventDefault(); open(t); return; }
    if (panel && !panel.hidden && !panel.contains(e.target) && !t) close();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel && !panel.hidden) { close(); if (owner) owner.focus(); } });
  addEventListener('scroll', function () { if (panel && !panel.hidden) { if (fine && owner) place(owner); else close(); } }, { passive: true });
  addEventListener('resize', function () { if (panel && !panel.hidden && owner) place(owner); });

  /* "Get my quote now" in the header pill opens the flyout ready to type */
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('.amc-qpop__go--quote'))) return;
    setTimeout(function () { var f = document.querySelector('.amc-qd [data-qd-form] input[name="email"]'), n = document.querySelector('.amc-qd [data-qd-form] input[name="name"]'); var x = n && !n.value ? n : f; if (x && !x.closest('[hidden]')) x.focus({ preventScroll: true }); }, 380);
  });
})();

/* AMC quote search: interactive layer (chips, steppers, highlight, keyboard, toasts, custom item card) */
(function () {
  var CHIPS = [['Racks', 'rack'], ['Lifts', 'lift'], ['Body boards', 'body board'], ['Trays', 'tray'], ['Cots', 'cot'], ['Embalming tables', 'embalming table'], ['Coolers', 'cooler'], ['Carts', 'cart']];
  var TYPES = ['Custom walk-in', 'Custom size', 'Replacement part', 'Accessory', 'Other'];
  var CHECK = '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function Q() { return window.AMCQuote; }
  function snap() { var m = {}; try { (Q().items() || []).forEach(function (i) { m[i.key] = +(i.qty || i.quantity || 0); }); } catch (e) {} return m; }
  function changed(before) { var hit = null; try { (Q().items() || []).forEach(function (i) { var q = +(i.qty || i.quantity || 0); if (!(i.key in before) || q > before[i.key]) hit = i; }); } catch (e) {} return hit; }
  var toastEl, toastT;
  function toast(html, key) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'amc-qx-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<span class="amc-qx-toast__ic">' + CHECK + '</span><span class="amc-qx-toast__t">' + html + '</span>' + (key ? '<button type="button" class="amc-qx-toast__go">View</button>' : '');
    var go = toastEl.querySelector('.amc-qx-toast__go');
    if (go) go.onclick = function () { var el = item(key); if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); pulse(el); } hide(); };
    toastEl.classList.remove('is-in'); void toastEl.offsetWidth; toastEl.classList.add('is-in');
    clearTimeout(toastT); toastT = setTimeout(hide, 3600);
  }
  function hide() { if (toastEl) toastEl.classList.remove('is-in'); }
  function item(key) { return [].find.call(document.querySelectorAll('.amc-qb__item[data-key], [data-amc-qb-list] [data-key]'), function (x) { return x.dataset.key === key; }); }
  function pulse(el) { if (!el) return; el.classList.remove('amc-qx-new'); void el.offsetWidth; el.classList.add('amc-qx-new'); setTimeout(function () { el.classList.remove('amc-qx-new'); }, 1900); }
  function after(before, label) {
    var tries = 0;
    (function look() {
      var hit = changed(before);
      if (!hit) { if (++tries < 12) return setTimeout(look, 150); return; }
      setTimeout(function () { pulse(item(hit.key)); }, 60);
      toast('<strong>Added to your quote</strong> ' + esc(label || hit.title) + (hit.qty > 1 ? ' &times; ' + hit.qty : ''), hit.key);
      document.querySelectorAll('.amc-qs').forEach(badges);
    })();
  }
  function stepper(input, cls) {
    if (!input || input.closest('.amc-qx-step')) return;
    var w = document.createElement('span'); w.className = 'amc-qx-step ' + (cls || '');
    input.parentNode.insertBefore(w, input);
    w.innerHTML = '<button type="button" class="amc-qx-step__b" data-d="-1" aria-label="Decrease quantity">&minus;</button>';
    w.appendChild(input);
    w.insertAdjacentHTML('beforeend', '<button type="button" class="amc-qx-step__b" data-d="1" aria-label="Increase quantity">+</button>');
    input.setAttribute('inputmode', 'numeric');
    w.addEventListener('click', function (e) {
      var b = e.target.closest('.amc-qx-step__b'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + +b.dataset.d); input.value = v;
      w.classList.remove('is-bump'); void w.offsetWidth; w.classList.add('is-bump');
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    input.addEventListener('blur', function () { if (!(parseInt(input.value, 10) >= 1)) input.value = 1; });
  }
  function badges(root) {
    var qty = {}; try { (Q().items() || []).forEach(function (i) { if (i.handle) qty[i.handle] = (qty[i.handle] || 0) + (+(i.qty || i.quantity || 0)); }); } catch (e) {}
    root.querySelectorAll('.amc-qs__row').forEach(function (r) {
      var n = qty[r.dataset.handle], b = r.querySelector('.amc-qx-in');
      if (!n) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('span'); b.className = 'amc-qx-in'; var info = r.querySelector('.amc-qs__info'); info.insertBefore(b, info.children[1] || null); }
      b.innerHTML = CHECK + ' In your quote &times; ' + n;
    });
  }
  function init(root) {
    if (root.dataset.qx) return; root.dataset.qx = '1';
    var input = root.querySelector('[data-amc-qs-input]'), out = root.querySelector('[data-amc-qs-results]');
    if (!input || !out) return;
    root.classList.add('amc-qx');
    if ((root.dataset.target || 'amc') === 'amc') input.placeholder = 'Product name, model or SKU';
    var box = root.querySelector('.amc-qs__box');
    box.insertAdjacentHTML('beforeend', '<span class="amc-qx-spin" aria-hidden="true"></span><button type="button" class="amc-qx-clear" aria-label="Clear search" hidden>&times;</button>');
    var clr = box.querySelector('.amc-qx-clear'), chipsEl = null;
    if ((root.dataset.target || 'amc') === 'amc') {
      box.insertAdjacentHTML('afterend', '<div class="amc-qx-chips" role="group" aria-label="Popular categories">' + CHIPS.map(function (c) { return '<button type="button" class="amc-qx-chip" data-q="' + esc(c[1]) + '">' + esc(c[0]) + '</button>'; }).join('') + '</div>');
      chipsEl = root.querySelector('.amc-qx-chips');
      chipsEl.addEventListener('click', function (e) {
        var c = e.target.closest('.amc-qx-chip'); if (!c) return;
        var on = c.classList.contains('is-on');
        chipsEl.querySelectorAll('.is-on').forEach(function (x) { x.classList.remove('is-on'); });
        if (on) { input.value = ''; } else { c.classList.add('is-on'); input.value = c.dataset.q; }
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus({ preventScroll: true });
      });
    }
    var loadT;
    function sync() {
      var t = input.value.trim(); clr.hidden = !t;
      if (chipsEl) chipsEl.querySelectorAll('.amc-qx-chip').forEach(function (c) { c.classList.toggle('is-on', c.dataset.q === t.toLowerCase()); });
      clearTimeout(loadT);
      if (t.length >= 2) { root.classList.add('is-loading'); loadT = setTimeout(function () { root.classList.remove('is-loading'); }, 5000); } else root.classList.remove('is-loading');
    }
    input.addEventListener('input', sync);
    clr.addEventListener('click', function () { input.value = ''; input.dispatchEvent(new Event('input', { bubbles: true })); input.focus(); });
    function decorate() {
      root.classList.remove('is-loading'); clearTimeout(loadT);
      var rows = out.querySelectorAll('.amc-qs__row'), term = input.value.trim();
      var head = out.querySelector('.amc-qx-head');
      if (rows.length) {
        if (!head) { head = document.createElement('div'); head.className = 'amc-qx-head'; out.insertBefore(head, out.firstChild); }
        head.innerHTML = '<span><strong>' + rows.length + '</strong> result' + (rows.length === 1 ? '' : 's') + ' for &ldquo;' + esc(term) + '&rdquo;</span><span class="amc-qx-head__k">&uarr;&darr; to move &middot; Enter to add</span>';
      } else if (head) head.remove();
      var words = term.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
      var re = words.length ? new RegExp('(' + words.join('|') + ')', 'ig') : null;
      rows.forEach(function (r, i) {
        if (r.dataset.qx) return; r.dataset.qx = '1';
        r.style.setProperty('--i', i);
        var a = r.querySelector('.amc-qs__info a');
        if (a && re) a.innerHTML = esc(a.textContent).replace(re, '<mark>$1</mark>');
        stepper(r.querySelector('.amc-qs__qty'), 'amc-qx-step--row');
        r.addEventListener('mouseenter', function () { setActive(i, true); });
      });
      badges(root);
      var none = out.querySelector('.amc-qs__none');
      if (none && !none.dataset.qx && term) {
        none.dataset.qx = '1';
        none.innerHTML = '<strong>No match for &ldquo;' + esc(term) + '&rdquo;.</strong> We can still quote it.';
        none.insertAdjacentHTML('afterend', '<button type="button" class="amc-qx-asc">+ Add &ldquo;' + esc(term.slice(0, 60)) + '&rdquo; as a custom item</button>');
        out.querySelector('.amc-qx-asc').addEventListener('click', function () {
          var t = root.querySelector('[data-amc-qs-custom-text]'); openCustom(true);
          if (t) { t.value = term.slice(0, 200); t.dispatchEvent(new Event('input', { bubbles: true })); }
          out.hidden = true;
          var q = root.querySelector('[data-amc-qs-custom-qty]'); if (q) q.focus();
        });
      }
      active = -1;
    }
    new MutationObserver(decorate).observe(out, { childList: true });
    var active = -1;
    function setActive(i, quiet) {
      var rows = out.querySelectorAll('.amc-qs__row'); if (!rows.length) return;
      active = (i + rows.length) % rows.length;
      rows.forEach(function (r, k) { r.classList.toggle('is-active', k === active); });
      if (!quiet) rows[active].scrollIntoView({ block: 'nearest' });
    }
    input.addEventListener('keydown', function (e) {
      if (out.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); setActive(active + (e.key === 'ArrowDown' ? 1 : -1)); }
      else if (e.key === 'Escape') { out.hidden = true; }
      else if (e.key === 'Enter' && active > -1) {
        var r = out.querySelectorAll('.amc-qs__row')[active], b = r && r.querySelector('.amc-qs__add');
        if (b) { e.preventDefault(); e.stopPropagation(); b.click(); }
      }
    });
    out.addEventListener('click', function (e) {
      var b = e.target.closest('.amc-qs__add'); if (!b || b.disabled) return;
      var r = b.closest('.amc-qs__row'), a = r && r.querySelector('.amc-qs__info a');
      var before = snap(); r.classList.add('is-adding');
      var mo = new MutationObserver(function () {
        if (/Added/.test(b.textContent)) { if (b.classList.contains('is-added')) return; b.classList.add('is-added'); b.innerHTML = CHECK + ' Added'; r.classList.remove('is-adding'); r.classList.add('is-added'); }
        else if (/^Add$/.test(b.textContent.trim())) { b.classList.remove('is-added'); r.classList.remove('is-added', 'is-adding'); mo.disconnect(); }
      });
      mo.observe(b, { childList: true, characterData: true, subtree: true });
      after(before, a && a.textContent);
    }, true);
    /* Custom item card */
    var cf = root.querySelector('[data-amc-qs-custom]');
    function openCustom(on) {
      if (!cf) return;
      cf.classList.toggle('is-open', on);
      var t = cf.querySelector('.amc-qx-ct'); if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    if (cf) {
      var lab = cf.querySelector('.amc-qs__label'), row = cf.querySelector('.amc-qs__crow');
      var txt = cf.querySelector('[data-amc-qs-custom-text]'), qty = cf.querySelector('[data-amc-qs-custom-qty]'), add = cf.querySelector('[data-amc-qs-custom-add]');
      cf.classList.add('amc-qx-cf');
      var tg = document.createElement('button'); tg.type = 'button'; tg.className = 'amc-qx-ct'; tg.setAttribute('aria-expanded', 'false');
      tg.innerHTML = '<span class="amc-qx-ct__ic" aria-hidden="true">+</span><span class="amc-qx-ct__t"><strong>Need something not listed?</strong><small>Describe it and we will quote it with your order.</small></span><span class="amc-qx-ct__ch" aria-hidden="true"></span>';
      cf.insertBefore(tg, cf.firstChild);
      if (lab) lab.classList.add('amc-qx-sr');
      var body = document.createElement('div'); body.className = 'amc-qx-cb'; cf.appendChild(body);
      var inner = document.createElement('div'); inner.className = 'amc-qx-cb__in'; body.appendChild(inner);
      inner.insertAdjacentHTML('beforeend', '<div class="amc-qx-types" role="radiogroup" aria-label="Item type">' + TYPES.map(function (t, i) { return '<button type="button" role="radio" aria-checked="' + (t === 'Other' ? 'true' : 'false') + '" class="amc-qx-type' + (t === 'Other' ? ' is-on' : '') + '" data-t="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</div>');
      if (lab) inner.appendChild(lab);
      inner.appendChild(row);
      txt.placeholder = 'Item, size, model or part number';
      var cnt = document.createElement('span'); cnt.className = 'amc-qx-cnt'; cnt.textContent = '0/200';
      txt.insertAdjacentElement('afterend', cnt);
      stepper(qty, 'amc-qx-step--custom');
      add.innerHTML = '<span>Add to quote</span>';
      tg.addEventListener('click', function () { var o = !cf.classList.contains('is-open'); openCustom(o); if (o) setTimeout(function () { txt.focus({ preventScroll: true }); }, 220); });
      var type = 'Other';
      inner.querySelector('.amc-qx-types').addEventListener('click', function (e) {
        var b = e.target.closest('.amc-qx-type'); if (!b) return;
        type = b.dataset.t;
        inner.querySelectorAll('.amc-qx-type').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
        txt.focus({ preventScroll: true });
      });
      function deepLink() {
        if (window.__amcQxDeep === cf) return;
        var m = /custom-walk-in/i.test(location.hash) || /^walk-?in$/i.test(new URLSearchParams(location.search).get('custom') || '');
        if (!m || (window.__amcQxDeep && window.__amcQxDeep !== cf)) return;
        window.__amcQxDeep = cf;
        var from = (new URLSearchParams(location.search).get('from') || '').replace(/[^0-9a-z x×\-]/gi, '').slice(0, 40);
        var b = inner.querySelector('.amc-qx-type[data-t="Custom walk-in"]'); if (b) b.click();
        txt.placeholder = 'Interior size (W × D × H), cooler or freezer, door location, body capacity';
        if (from && !txt.value) txt.value = 'Starting from ' + from.replace(/(\d+)\s*x\s*(\d+)/i, '$1\u2032 \u00d7 $2\u2032').replace(/-/g, ' ') + ': ';
        openCustom(true); count();
        setTimeout(function () { txt.focus({ preventScroll: true }); cf.scrollIntoView({ block: 'center' }); }, 700);
      }
      window.addEventListener('hashchange', function () { if (window.__amcQxDeep === cf) window.__amcQxDeep = null; deepLink(); });
      setTimeout(deepLink, 120);
      function count() { var n = txt.value.length; cnt.textContent = n + '/200'; cnt.classList.toggle('is-warn', n > 170); add.classList.toggle('is-ready', !!txt.value.trim()); }
      txt.addEventListener('input', count);
      cf.addEventListener('click', function (e) {
        if (!e.target.closest('[data-amc-qs-custom-add]')) return;
        var v = txt.value.trim();
        if (!v) { row.classList.remove('is-shake'); void row.offsetWidth; row.classList.add('is-shake'); txt.focus(); return; }
        if (type !== 'Other' && v.toLowerCase().indexOf(type.toLowerCase()) !== 0) txt.value = (type + ': ' + v).slice(0, 200);
        var before = snap(), label = txt.value.trim();
        setTimeout(function () { type = 'Other'; inner.querySelectorAll('.amc-qx-type').forEach(function (x) { var on = x.dataset.t === 'Other'; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); }); count(); add.classList.add('is-added'); add.innerHTML = CHECK + ' Added'; setTimeout(function () { add.classList.remove('is-added'); add.innerHTML = '<span>Add to quote</span>'; }, 1600); }, 30);
        after(before, label);
      }, true);
    }
  }
  function boot() { document.querySelectorAll('[data-amc-qs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); }); else setTimeout(boot, 0);
})();

/* Route legacy catalog/finance links to the existing procurement builder.
   Preserve product, variant, intent and other context; do not alter quote-view links. */
(function () {
  'use strict';
  var selector = 'a[href*="/pages/request-quote"],a[href*="/pages/rfq-center"]';
  var current = new URL(window.location.href);
  if (/^\/pages\/(?:request-quote|rfq-center)\/?$/.test(current.pathname)) {
    current.pathname = '/pages/purchase-order';
    if (!current.searchParams.has('type')) current.searchParams.set('type', 'rfq');
    window.location.replace(current.pathname + current.search + current.hash);
    return;
  }
  function update(link) {
    var url;
    try { url = new URL(link.getAttribute('href'), window.location.origin); } catch (_) { return; }
    if (url.origin !== window.location.origin ||
        !/^\/pages\/(?:request-quote|rfq-center)\/?$/.test(url.pathname)) return;
    url.pathname = '/pages/purchase-order';
    if (!url.searchParams.has('type')) url.searchParams.set('type', 'rfq');
    link.setAttribute('href', url.pathname + url.search + url.hash);
  }
  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches(selector)) update(root);
    root.querySelectorAll(selector).forEach(update);
  }
  function boot() {
    scan(document.body);
    new MutationObserver(function (records) {
      records.forEach(function (record) { record.addedNodes.forEach(scan); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
